import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
export var getAddressByLatLng = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lat, lng) {
    var key, url, _yield$axios$get$then, results;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            key = process.env.LOCALSTITCH_DEV_GOOGLE_API_KEY;
            url = "https://maps.googleapis.com/maps/api/geocode/json?language=ko&latlng=".concat(lat, ", ").concat(lng, "&key=").concat(key, "&result_type=street_address");
            _context.next = 4;
            return axios.get(url).then(function (res) {
              return res.data;
            });

          case 4:
            _yield$axios$get$then = _context.sent;
            results = _yield$axios$get$then.results;
            return _context.abrupt("return", results[0].formatted_address);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAddressByLatLng(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getDistanceFromLatLonInKm = function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var deg2rad = function deg2rad(deg) {
    return deg * (Math.PI / 180);
  };

  var R = 6371; // Radius of the earth in km

  var dLat = deg2rad(lat2 - lat1); // deg2rad below

  var dLon = deg2rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};